import React from 'react';
import Hero from '../components/Hero';
import AboutTeaser from '../components/AboutTeaser';
import ServicesTeaser from '../components/ServicesTeaser';
import GalleryTeaser from '../components/GalleryTeaser';
import ContactTeaser from '../components/ContactTeaser';

const Home = () => {
  return (
    <div>
      <Hero />
      <AboutTeaser />
      <ServicesTeaser />
      <GalleryTeaser />
      <ContactTeaser />
    </div>
  );
};

export default Home;